<button type="button"
        *ngFor="let localActionKey of localActions | keys"
        [ngClass]="getClass(localActionKey)"
        (click)="localActionClicked($event, localActionKey, localActions[localActionKey])">
  {{ localActions[localActionKey].Title }}
</button>
